import StringUtilService from 'commons-forms/services/StringUtilService/StringUtilService.js';
import ValidationService from 'commons-forms/services/ValidationService/ValidationService.js';
import GroupResponseService from 'commons-forms/services/GroupResponseService/GroupResponseService.js';

import InputCheckbox from 'commons-forms/components/InputCheckbox/InputCheckbox.jsx';
import InputEmail from 'commons-forms/components/InputEmail/InputEmail.jsx';
import InputPhoneNumber from 'commons-forms/components/InputPhoneNumber/InputPhoneNumber.jsx';
import InputText from 'commons-forms/components/InputText/InputText.jsx';
import InputDropDown from 'commons-forms/components/InputDropDown/InputDropDown.jsx';
import InputDropDownMultiple from 'commons-forms/components/InputDropDown/InputDropDownMultiple.jsx';
import DatePicker from 'commons-forms/components/DatePicker/DatePicker.jsx';
import InputZipCode from 'commons-forms/components/InputZipCode/InputZipCode.jsx';
import IdentityGroup from 'commons-forms/components/Groups/IdentityGroup.jsx';
import AddressGroup from 'commons-forms/components/Groups/AddressGroup.jsx';
import ErrorsHandler from 'commons-forms/components/ErrorsHandler/ErrorsHandler.jsx';
import InputRadioContainer from 'commons-forms/components/InputRadio/InputRadioContainer.jsx';
import InputRadio from 'commons-forms/components/InputRadio/InputRadio.jsx';
import InputColorRadioContainer from 'commons-forms/components/InputColorRadio/InputColorRadioContainer.jsx';
import InputColorRadio from 'commons-forms/components/InputColorRadio/InputColorRadio.jsx';
import TextArea from 'commons-forms/components/TextArea/TextArea.jsx';
import FormBuilder from 'commons-forms/components/FormBuilder/FormBuilder.jsx';
import MessageHandler from 'commons-forms/components/MessageHandler/MessageHandler.jsx';
import InputCheckBoxContainer from 'commons-forms/components/InputCheckbox/InputCheckboxContainer.jsx';
import InputFormatCurrency from 'commons-forms/components/InputFormatCurrency/InputFormatCurrency.jsx';
import InputAutoComplete from 'commons-forms/components/InputAutoComplete/InputAutoComplete.jsx';
import InputNumber from 'commons-forms/components/InputNumber/InputNumber.jsx';
import Wizard from 'commons-forms/components/Wizard/Wizard.jsx';

import KEY_CODES from 'commons-forms/constants/keycodes.js';
import COUNTRIES from 'commons-forms/constants/countries.js';
import FIELD_LENGTH from 'commons-forms/constants/fieldLength.js';

import en from 'commons-forms/i18n/en.json';
import fr from 'commons-forms/i18n/fr.json';

const Translations = { en, fr };

const Groups = {
    IdentityGroup,
    AddressGroup,
};

export {
    StringUtilService,
    ValidationService,
    GroupResponseService,
    InputCheckbox,
    InputEmail,
    InputPhoneNumber,
    InputText,
    InputDropDown,
    InputDropDownMultiple,
    DatePicker,
    InputZipCode,
    Groups,
    ErrorsHandler,
    KEY_CODES,
    FIELD_LENGTH,
    COUNTRIES,
    Translations,
    InputRadioContainer,
    TextArea,
    FormBuilder,
    InputRadio,
    MessageHandler,
    InputCheckBoxContainer,
    InputFormatCurrency,
    InputAutoComplete,
    InputNumber,
    Wizard,
    InputColorRadio,
    InputColorRadioContainer,
};

export default {
    StringUtilService,
    ValidationService,
    GroupResponseService,
    InputCheckbox,
    InputEmail,
    InputPhoneNumber,
    InputText,
    InputDropDown,
    InputDropDownMultiple,
    DatePicker,
    InputZipCode,
    Groups,
    ErrorsHandler,
    KEY_CODES,
    FIELD_LENGTH,
    COUNTRIES,
    Translations,
    InputRadioContainer,
    TextArea,
    FormBuilder,
    InputRadio,
    MessageHandler,
    InputCheckBoxContainer,
    InputFormatCurrency,
    InputAutoComplete,
    InputNumber,
    Wizard,
    InputColorRadioContainer,
    InputColorRadio,
};
